import { CurrencySchema, ObjectIdSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const HomePageTopGrossingSchema = oz.object({
  id: ObjectIdSchema,
  name: oz.string().nonempty(),
  currentRevenue: oz.number(),
  previousRevenue: oz.number(),
  currency: CurrencySchema.optional(),
}).openapi('HomePageTopGrossing');

export type HomePageTopGrossing = oz.infer<typeof HomePageTopGrossingSchema>;